// extracted by mini-css-extract-plugin
export var active = "PageUnavailable-module--active--4736b";
export var container = "PageUnavailable-module--container--be2ad";
export var list = "PageUnavailable-module--list--3999f";
export var list__listItem = "PageUnavailable-module--list__list-item--62273";
export var list__listItemLink = "PageUnavailable-module--list__list-item-link--69f34";
export var title = "PageUnavailable-module--title--23e92";